<template>

  <!-- Overlay Start -->
  <div class="overlay"></div>
  <!-- Overlay End -->

  <!-- Page Banner Start -->
  <div class="section page-banner">

    <!-- <img class="shape-1 animation-round" src="/assets/images/shape/shape-8.png" alt="Shape"> -->

    <img class="shape-2" src="/assets/images/shape/shape-23.png" alt="Shape">

    <div class="container">
      <!-- Page Banner Start -->
      <div class="page-banner-content">
        <ul class="breadcrumb">
          <li><a href="#">Home</a></li>
          <li class="active">FAQ</li>
        </ul>
        <h2 class="title">Frequently Asked <span>Question.</span></h2>
      </div>
      <!-- Page Banner End -->
    </div>

    <!-- Shape Icon Box Start -->
    <div class="shape-icon-box">

      <img class="icon-shape-1 animation-left" src="/assets/images/shape/shape-5.png" alt="Shape">

      <div class="box-content">
        <div class="box-wrapper">
          <i class="flaticon-badge"></i>
        </div>
      </div>

      <img class="icon-shape-2" src="/assets/images/shape/shape-6.png" alt="Shape">

    </div>
    <!-- Shape Icon Box End -->

    <img class="shape-3" src="/assets/images/shape/shape-24.png" alt="Shape">

    <img class="shape-author" src="/assets/images/author/author-18.jpg" alt="Shape">

  </div>
  <!-- Page Banner End -->

  <!-- FAQ Start -->
  <div class="section padding-bottom-50">
    <div class="container">

      <!-- FAQ Tab Content Start -->
      <div class="tab-content">
        <div class="tab-pane fade show active" id="tab1">
          <!-- FAQ Wrapper Start -->
          <div class="faq-wrapper">

            <!-- Single FAQ Item Start -->
            <div class="single-faq-item">
              <div class="row align-items-center">
                <div class="col-lg-5">
                  <div class="faq-title">
                    <h4 class="title">What is The COLREGs?</h4>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="faq-text">
                    <p>The COLREGs is an online platform that provides practice exams and final tests to help users prepare for the MSQ exam required for a sailor's license.</p>
                    <p>Our platform offers a variety of test packages designed to simulate real exam conditions for effective preparation.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Single FAQ Item End -->

            <!-- Single FAQ Item Start -->
            <div class="single-faq-item">
              <div class="row align-items-center">
                <div class="col-lg-5">
                  <div class="faq-title">
                    <h4 class="title">What packages are available on The COLREGs?</h4>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="faq-text">
                    <p>We offer three packages: Free Trial (10 questions), Standard (30 questions), and Premium (60 or 90 questions).</p>
                    <p>Each package includes a mix of practice tests and time-bound final exams to help users prepare effectively.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Single FAQ Item End -->

            <!-- Single FAQ Item Start -->
            <div class="single-faq-item">
              <div class="row align-items-center">
                <div class="col-lg-5">
                  <div class="faq-title">
                    <h4 class="title">How do I register for a package?</h4>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="faq-text">
                    <p>Simply click the Sign Up button, fill in your details, and select your desired package.</p>
                    <p>For paid packages, you'll be redirected to a secure payment gateway before gaining access to tests.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Single FAQ Item End -->

            <!-- Single FAQ Item Start -->
            <div class="single-faq-item">
              <div class="row align-items-center">
                <div class="col-lg-5">
                  <div class="faq-title">
                    <h4 class="title">Is there a time limit on the final tests?</h4>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="faq-text">
                    <p>Yes. Final tests are time-bound to simulate real exam conditions, while practice tests are not time-restricted.</p>
                    <p>This helps users improve time management and exam readiness.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Single FAQ Item End -->

            <!-- Single FAQ Item Start -->
            <div class="single-faq-item">
              <div class="row align-items-center">
                <div class="col-lg-5">
                  <div class="faq-title">
                    <h4 class="title">Can I retake the final tests?</h4>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="faq-text">
                    <p>Yes, you can attempt final tests multiple times. However, a maximum limit applies based on the package selected.</p>
                    <p>Each attempt presents a randomized set of questions to enhance learning.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Single FAQ Item End -->

            <!-- Single FAQ Item Start -->
            <div class="single-faq-item">
              <div class="row align-items-center">
                <div class="col-lg-5">
                  <div class="faq-title">
                    <h4 class="title">Will my test results be saved?</h4>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="faq-text">
                    <p>Yes. All test results are saved in your user dashboard, where you can review previous attempts and track your progress.</p>
                    <p>This helps you identify areas for improvement and focus on weak topics.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Single FAQ Item End -->

            <!-- Single FAQ Item Start -->
            <div class="single-faq-item">
              <div class="row align-items-center">
                <div class="col-lg-5">
                  <div class="faq-title">
                    <h4 class="title">Can I upgrade my package?</h4>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="faq-text">
                    <p>Yes. Users can upgrade to a higher package anytime through their dashboard by paying the difference in cost.</p>
                    <p>This unlocks additional questions and more test attempts.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Single FAQ Item End -->

            <!-- Single FAQ Item Start -->
            <div class="single-faq-item">
              <div class="row align-items-center">
                <div class="col-lg-5">
                  <div class="faq-title">
                    <h4 class="title">What payment methods do you accept?</h4>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="faq-text">
                    <p>We accept payments via credit/debit cards, PayPal, and other secure payment gateways.</p>
                    <p>All transactions are encrypted to ensure a safe checkout experience.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Single FAQ Item End -->

            <!-- Single FAQ Item Start -->
            <div class="single-faq-item">
              <div class="row align-items-center">
                <div class="col-lg-5">
                  <div class="faq-title">
                    <h4 class="title">How can organizations purchase bulk packages?</h4>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="faq-text">
                    <p>Organizations can fill out the bulk purchase inquiry form, and we'll provide a customized deal based on their requirements.</p>
                    <p>A dedicated account manager will assist in setting up team accounts and tracking performance.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Single FAQ Item End -->

            <!-- Single FAQ Item Start -->
            <div class="single-faq-item">
              <div class="row align-items-center">
                <div class="col-lg-5">
                  <div class="faq-title">
                    <h4 class="title">How do I contact support?</h4>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="faq-text">
                    <p>You can reach our support team via the <router-link to="/contact">Contact Us</router-link> page or email us directly.</p>
                    <p>Our team typically responds within 24 hours to assist with any concerns or technical issues.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Single FAQ Item End -->


          </div>
          <!-- FAQ Wrapper End -->
        </div>

      </div>
      <!-- FAQ Tab Content End -->

    </div>
  </div>
  <!-- FAQ End -->

</template>

<script>
export default {
  name: 'FAQ',
};
</script>
